<template>
  <screen-locker>
    <template v-slot:content>
      <div
        class="page page-user-personal-data d-flex flex-column"
        v-if="!showLoadingNextStep"
      >
        <AppHeader :step-active="1"></AppHeader>
        <div class="row header-page">
          <div class="col">
            <h3>Le tue informazioni personali</h3>
            <div class="row h-100">
              <div class="col h-100">
                <div
                  class="banner banner-user-info h-100 d-flex align-items-center"
                >
                  <div
                    class="svg-banner-user-info w-100"
                    v-bind:class="getBannerClasses()"
                  >
                    <svg-viewer
                      @loaded="loadSvgButtons()"
                      :src="
                        window.width <= 1440
                          ? require('../assets/images/banner/01-main.svg')
                          : require('../assets/images/banner/01-wide.svg')
                      "
                      width="100%"
                      :height="window.width <= 1440 ? '350px' : '430px'"
                    ></svg-viewer>
                  </div>
                  <div class="generali-plus pointer">&nbsp;</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-data user-data pt-auto w-100">
          <div class="row">
            <div class="col-sm-6 col-xs-12 mt-3">
              <label class="component-label">Genere</label>
              <radio-switcher
                :elems="genderList"
                v-model="genderValue"
              ></radio-switcher>
            </div>
            <div class="col-sm-6 col-xs-12 mt-3">
              <label class="component-label">Età</label>
              <radio-switcher
                :elems="ageList"
                v-model="ageValue"
              ></radio-switcher>
            </div>
            <div class="col-sm-6 col-xs-12 mt-3">
              <label class="component-label">Premio versato (&euro;)</label>
              <input-spinner
                v-model="capitalValue"
                :min="capitalMin"
                :max="capitalMax"
                :step="capitalStep"
              ></input-spinner>
            </div>
            <div class="col-sm-6 col-xs-12 mt-3">
              <label class="component-label"
                >Periodo di simulazione (anni)</label
              >
              <radio-switcher
                :elems="yearList"
                v-model="yearValue"
              ></radio-switcher>
            </div>
          </div>
        </div>
        <div class="footer-page w-100">
          <div class="d-flex">
            <b-button variant="link" @click="back()">
              <img alt="Indietro" src="../assets/images/back.svg" />
              Indietro
            </b-button>
            <b-button
              variant="primary ml-auto"
              :disabled="disabledNextStep()"
              @click="processData()"
              >Inizia</b-button
            >
          </div>
        </div>
        <auth-guard />
      </div>
    </template>
  </screen-locker>
</template>

<script>
import router from "../router";
import { UserCollectionData } from "../data/user-collections.data";
export default {
  name: "UserPersonalData",
  data: () => {
    return {
      val: "",
      switcherColor: "#FFFFFF",
      switcherBackgroundColor: "#a81b38",
      capitalValue: 0,
      capitalMin: 10000,
      capitalMax: 250000,
      capitalStep: 5000,
      genderValue: "Uomo",
      ageValue: "",
      yearValue: "",
      generaliPlusValue: false,
      generaliBilanciaValue: false,
      genderList: [],
      ageList: [],
      yearList: [],
      window: {
        width: 0,
        height: 0
      },
      showLoadingNextStep: false
    };
  },
  created() {
    this.genderList = UserCollectionData.genderList;
    this.ageList = UserCollectionData.ageList;
    this.yearList = UserCollectionData.yearList;
    this.capitalValue = this.$store.state.capitalValue;
    this.genderValue = "" + this.$store.state.genderValue;
    this.yearValue = "" + this.$store.state.yearValue;
    this.ageValue = "" + this.$store.state.ageValue;
    this.generaliPlusValue = this.$store.state.generaliPlusValue;
    this.generaliBilanciaValue = this.$store.state.generaliBilanciaValue;
    this.loadSvgButtons();
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.loadSvgButtons();
  },
  methods: {
    disabledNextStep() {
      return (
        this.genderValue == "" || this.ageValue == "" || this.yearValue == ""
      );
    },
    processData() {
      if (!this.disabledNextStep()) {
        // this.showLoadingNextStep = true;
        this.saveState();
        router.push("areas");
      }
    },
    saveState() {
      if (
        this.$store.state.generaliPlusValue !== this.generaliPlusValue ||
        this.$store.state.ageValue !== this.ageValue
      ) {
        this.$store.commit("setExtraProtectionValue", []);
      }
      this.$store.commit("setCapitalValue", this.capitalValue);
      this.$store.commit("setGenderValue", this.genderValue);
      this.$store.commit("setYearValue", this.yearValue);
      this.$store.commit("setAgeValue", this.ageValue);
      this.$store.commit("setGeneraliPlusValue", this.generaliPlusValue);
      this.$store.commit(
        "setGeneraliBilanciaValue",
        this.generaliBilanciaValue
      );
    },
    back() {
      router.push("/");
    },
    getBannerClasses() {
      const result = [];
      let className = "";
      // #LC 20200312
      // hide piu generali class-> disable piu generali option
      // const generaliPiuClass = this.generaliPlusValue ? 'svg-remove-piu-generali' : 'svg-add-piu-generali';
      const generaliBilanciaClass = this.generaliBilanciaValue
        ? "svg-add-bilancia"
        : "svg-remove-bilancia";
      const generaliPiuClass = "";
      className = `svg-${this.genderValue.toLocaleLowerCase()}-${
        this.ageValue
      } ${generaliPiuClass} ${generaliBilanciaClass}`;
      result.push(className);
      // result.push("svg-animate");
      return result;
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    loadSvgButtons() {
      if (document.querySelector(".svg-banner-user-info") == null) {
        return;
      }
      // #LC 20200312
      // disable click -> disable piu generali option
      document
        .querySelector(".svg-banner-user-info")
        .addEventListener("touchstart", event => this.handlerClick(event));
      document
        .querySelector(".svg-banner-user-info")
        .addEventListener("click", event => this.handlerClick(event));
    },
    handlerClick(event) {
      // più generali options
      if (
        (event.target.parentElement && event.target.parentElement.id === "add-btn") ||
        (event.path &&
          event.path.length > 0 &&
          event.path.filter(p => p.id === "add-btn").length > 0)
      ) {
        this.generaliPlusValue = true;
        return;
      }
      if (
        (event.target.parentElement && event.target.parentElement.id === "remove-btn") ||
        (event.path &&
          event.path.length > 0 &&
          event.path.filter(p => p.id === "remove-btn").length > 0)
      ) {
        this.generaliPlusValue = false;
        return;
      }
      if (
        event.targetTouches &&
        event.targetTouches.length > 0 &&
        event.targetTouches[0].target &&
        (event.targetTouches[0].target.id === "add-btn" ||
          event.targetTouches[0].target.id === "add-button")
      ) {
        this.generaliPlusValue = true;
        return;
      }
      if (
        event.targetTouches &&
        event.targetTouches.length > 0 &&
        event.targetTouches[0].target &&
        (event.targetTouches[0].target.id === "remove-btn" ||
          event.targetTouches[0].target.id === "remove-button")
      ) {
        this.generaliPlusValue = false;
        return;
      }
      if (
        event.targetTouches &&
        event.targetTouches.length > 0 &&
        event.targetTouches[0].target &&
        event.targetTouches[0].target.nextElementSibling &&
        (event.targetTouches[0].target.nextElementSibling.id == "add-button" ||
          event.targetTouches[0].target.nextElementSibling.id == "add-btn")
      ) {
        this.generaliPlusValue = true;
        return;
      }
      if (
        event.targetTouches &&
        event.targetTouches.length > 0 &&
        event.targetTouches[0].target &&
        event.targetTouches[0].target.nextElementSibling &&
        (event.targetTouches[0].target.nextElementSibling.id ==
          "remove-button" ||
          event.targetTouches[0].target.nextElementSibling.id == "remove-btn")
      ) {
        this.generaliPlusValue = false;
        return;
      }
      // console.log('event', event);
      // bilancia options
      if (
        (event.target.parentElement && event.target.parentElement.id === "add-btn-3") ||
        (event.path &&
          event.path.length > 0 &&
          event.path.filter(p => p.id === "add-btn-3").length > 0)
      ) {
        this.generaliBilanciaValue = true;
        return;
      }
      if (
        (event.target.parentElement && event.target.parentElement.id === "add-btn-2") ||
        (event.path &&
          event.path.length > 0 &&
          event.path.filter(p => p.id === "add-btn-2").length > 0)
      ) {
        this.generaliBilanciaValue = false;
        return;
      }
      if (
        event.targetTouches &&
        event.targetTouches.length > 0 &&
        event.targetTouches[0].target &&
        (event.targetTouches[0].target.id === "add-btn-3" ||
          event.targetTouches[0].target.id === "add-button-3")
      ) {
        this.generaliBilanciaValue = true;
        return;
      }
      if (
        event.targetTouches &&
        event.targetTouches.length > 0 &&
        event.targetTouches[0].target &&
        (event.targetTouches[0].target.id === "add-btn-2" ||
          event.targetTouches[0].target.id === "add-button-2")
      ) {
        this.generaliBilanciaValue = false;
        return;
      }
      if (
        event.targetTouches &&
        event.targetTouches.length > 0 &&
        event.targetTouches[0].target &&
        event.targetTouches[0].target.nextElementSibling &&
        (event.targetTouches[0].target.nextElementSibling.id ==
          "add-button-3" ||
          event.targetTouches[0].target.nextElementSibling.id == "add-btn-3")
      ) {
        this.generaliBilanciaValue = true;
        return;
      }
      if (
        event.targetTouches &&
        event.targetTouches.length > 0 &&
        event.targetTouches[0].target &&
        event.targetTouches[0].target.nextElementSibling &&
        (event.targetTouches[0].target.nextElementSibling.id ==
          "add-button-2" ||
          event.targetTouches[0].target.nextElementSibling.id == "add-btn-3")
      ) {
        this.generaliBilanciaValue = false;
        return;
      }
    },
    loaded() {
      this.showLoadingNextStep = false;
    }
  }
};
</script>
<style lang="scss"></style>
